module.exports = __webpack_public_path__ + "videos/selection-overlay.8416e6e.webm";